const prod = {
    url: {
      API_URL: "https://quote.qpsoftware.net/wp-json/quote",
      WEB_URL: "https://qpsoftware.net",
    },
  };
  const dev = {
    url: {
      API_URL: "https://quote.qpsoftware.net/wp-json/quote",
      WEB_URL: "https://qpsoftware.net",
    },
  };
  export const config = process.env.NODE_ENV === "development" ? dev : prod;
  